import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import Introduction004 from './Introduction004'
import Introduction005 from './Introduction005'
import Introduction006 from './Introduction006'
import Introduction007 from './Introduction007'
import Introduction008 from './Introduction008'
import Introduction009 from './Introduction009'
import Introduction010 from './Introduction010'
import Introduction011 from './Introduction011'
import Introduction012 from './Introduction012'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 30px;
  .p-txt-date {
    margin-top: -10px;
    color: #ababab;
  }
  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 16px;
    color: #505050;
    line-height: 1.6em;
    h1 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #f5f5f5;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-bottom: 30px;
      margin-top: 10px;
      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #77d7c9;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }
    h2 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #ffffff;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-top: 10px;
      margin-bottom: 30px;
      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #d8d8d8;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }
    h3 {
      color: #414141;
      font-size: 16px;
      line-height: 1.4em;
      background: #ffffff;
      width: auto;
      padding: 10px 0 8px;
      margin-top: -10px;
      margin-bottom: 20px;
      border-top: solid 2px #e5e5e5;
      border-bottom: solid 2px #e5e5e5;
    }
    p {
      padding-bottom: 30px;
      line-height: 2;
      position: relative;
      span {
        background: linear-gradient(transparent 60%, #ff6 60%);
        font-weight: 600;
      }
      .p-list-link {
        position: absolute;
        top: 6px;
        right: 2px;
        &:before {
          display: block;
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          top: 7px;
          left: -14px;
          border-left: 8px solid #3ec7b3;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
        }
      }
      &.txt-color-red {
        color: #ff6969;
      }
    }
    .link-div {
      width: 100%;
      display: flex;
      justify-content: left;
      padding-bottom: 30px;
      > div {
        width: 50px;
      }
      .link-p {
        width: calc(100% - 50px);
        .p-list-link {
          position: absolute;
          top: -3px;
          left: 30px;
          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 11px;
            left: -14px;
            border-left: 8px solid #3ec7b3;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
          }
        }
      }
    }
    img {
      width: 100%;
      height: auto;
      padding-bottom: 30px;
    }
  }
  ${BreakPoints.large} {
  }
`
type Props = {
  /** 広告の番号 */
  no: number
}

/**
 * コラム記事詳細：記事本体
 * @constructor
 */
const ColumnDetailInner0054 = (props: Props): JSX.Element => (
  <Wrapper>
    <ColumnH1 label="役員と有給休暇について。役員の働き方とは？" />
    {/** TODO 川上申し送り事項：▼投稿日をここに表示 */}
    <p className="p-txt-date">2023.07.11</p>
    <section>
      {/** TODO 川上申し送り事項：▼記事投稿（？）で作成された内容がここに入る予定 */}
      <p>
        多くの企業には労働者とは別に「役員」が在籍しています。
        <span>原則として役員は労働者ではありません</span>
        ので、労働関係法令の適用がないことに付随して、雇用保険の資格取得ができない等の特徴があります。今回は役員に対する働き方、有給休暇の有無、退任した場合にフォーカスをあて、解説します。
      </p>
      <img src="/images/column/details/c0054.jpg" alt="キンクラコラム画像54" />
      <h1 id="toc1">役員と労働者の違い</h1>
      <p>
        前提として、役員は労働者ではありませんので、原則として、労働基準法を始めとした労働関係法令の適用がありません。「原則として」という表現を用いた理由として、役員でありながら労働者的な性格を併せ持つという場合には画一的な対応はすべきではないからです。具体的な例として、雇用保険は労働者に対する保険ですので、代表取締役は例外なく加入ができません。
        <span>
          他方、役員でありながら労働者的な性格を併せ持つ場合、実態を勘案して、「兼務役員」という形で実態を証明し、ハローワークに認められた場合に限って雇用保険の資格を得ます。
        </span>
        実務的には登記簿謄本、定款、役員会議事録、就業規則、賃金台帳、出勤簿、労働者名簿、その他の関係書類を添付し、審査されます。例えば、出退勤の管理が全くされていない場合や、役員報酬のみで給与は全く支払われていないという場合、認められることは難しくなります。
      </p>

      <h1 id="toc2">有給休暇の有無について</h1>
      <p>
        純然たる役員の場合、繰り返しにはなりますが、労働基準法が適用されませんので、
        <span>有給休暇も付与されません。</span>
        反対に、出退勤の自由もあることから、時間的な拘束がないので、働き方の部分で後述するように、ある程度裁量をもった働き方が可能と言えます。また、役員の場合、時間によって給与を支払われる労働者とは異なり、「役員報酬」と言う形で定額の報酬が支払われるのが通例ですので、役員については、有給休暇がなくても直接的なデメリットはないと言えます。もちろん企業によっては、恩恵的に役員にも有給休暇のようなものを付与するというケースもあるのでしょうが、少なくとも労働基準法上の有給休暇とは別のものとなります。
        <br />
        <br />
        似て非なるものとして、管理職が挙げられます。一般的に管理職とは「残業代が出ない」と言われるケースが多いですが、労働基準法としては「管理監督者」という概念があります。端的には管理監督者とは労働時間、休憩、休日の規制がないため、「残業代が出ない」との解釈にいきつくわけですが、会社が掲げる管理職が労働基準法上の管理監督者とイコールになっているのかは時間をかけて精査すべきです。
      </p>

      {/** ここに9パターンの広告設定する */}
      {props.no === 0 && <Introduction004 />}
      {props.no === 1 && <Introduction005 />}
      {props.no === 2 && <Introduction006 />}
      {props.no === 3 && <Introduction007 />}
      {props.no === 4 && <Introduction008 />}
      {props.no === 5 && <Introduction009 />}
      {props.no === 6 && <Introduction010 />}
      {props.no === 7 && <Introduction011 />}
      {props.no === 8 && <Introduction012 />}

      <h1 id="toc3">働き方について</h1>
      <p>
        役員の場合、資金繰りなど、多くの労働者が扱うことのない経営的な業務を遂行していくこととなります。もちろん、ベテランの労働者の方が役員よりも知見を持っているというケースは少なくありませんので、その場合は当該ベテラン労働者の助力を受けながら業務を遂行していくこととなります。
        <br />
        <br />
        他方、労働者は1日8時間、１週間40時間が原則的に働くことが可能とされる時間であるため、会社からある程度の「ブレーキ」をかけられます。これは近年、社会問題化している過労死や長時間労働に起因した精神疾患等を防ぐ意味でも多くの会社が取り組んでいることです。しかし、役員の場合、「1日8時間、１週間40時間」という労働時間の制約がないだけでなく、「労働基準法上の労働時間」という概念すらありませんので、
        <span>自分自身で身を守る努力</span>
        をしなければ、労働者以上に健康被害を引き起こすリスクをはらんでいるということです。
      </p>

      <h1 id="toc4">役員退任後について</h1>
      <p>
        役員を退任し、その後も当該企業で働く場合を確認しましょう。もちろん、それ自体は可能ですが、注意しなければならないポイントがあります。役員を退任するということは、その後は業務委託契約等を締結し、フリーランスとして働く場合でもなければ、当該企業の1従業員として労務の提供をすることとなります。そうなると、これまで履行できていなくても問題にならなかった
        <span>
          残業代の支払いや有給休暇の5日取得義務への対応等が求められます。
        </span>
        もちろん、当事者にとってはプラスになることですが、企業にとっては管理すべき対象者が増えることになりますので、漏れがないように注意して業務を進めなければなりません。
        <br />
        <br />
        また、役員就任当時から全く労働者性がなく、雇用保険に加入していなかった場合には、役員を退任したことで、労働者となる場合はその時から
        <span>加入義務が生じます。</span>
        他方、社会保険については、役員であっても会社から報酬が発生していれば、当初から加入対象となっていますので、雇用保険のように労働者となった段階から加入ということではありません。ただし、報酬額が変動する場合は3か月間の給与額を基に変動月から4か月目に社会保険料が改定されます。社会保険料は「労使折半」となりますので、申請忘れは本人だけの問題ではなくなります。
      </p>

      <h1 id="toc5">最後に</h1>
      <p>
        役員の場合、法律上の有給休暇がないことや、役員のままの状態で（労働者になることなく）職を辞した後、失業保険がないなどのデメリットがありますが、それ以上に働き方にある程度の裁量があるという大きなメリットもあります。
      </p>
    </section>
  </Wrapper>
)

export default ColumnDetailInner0054
